/**
 * The labels a feedback group carries to its GitLab issue (openspec change
 * `feedback-triage-assist`): set by an operator, suggested by the assistant.
 */

/** A group's severity, carried by its GitLab issue as a `severity::` label. */
export const FEEDBACK_SEVERITIES = ["low", "medium", "high"] as const;
export type FeedbackSeverity = (typeof FEEDBACK_SEVERITIES)[number];

/**
 * The backlog's closed list of `area::` labels (GitLab project labels, 2026-11-02). A group's
 * area is one of them; its issue carries `area::<area>`.
 */
export const FEEDBACK_AREAS = [
  "agent",
  "api",
  "auth",
  "conversations",
  "db",
  "docs",
  "infra",
  "ingestion",
  "knowledge",
  "mcp",
  "ops",
  "security",
  "seed",
  "spec",
  "web",
  "wiki",
] as const;
export type FeedbackArea = (typeof FEEDBACK_AREAS)[number];
